module.exports = __webpack_public_path__ + "static/img/card-info.018f7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-info.png
// module id = iB9B
// module chunks = 34